<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import PresenceHome from "./PresenceHome.vue";
import EmployeeService from '@/api/services/employee.service';

import { computed, getCurrentInstance, ref } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import { usePresenceStore } from "@/app/stores/presenceStore";
import { useRoute } from "vue-router";

const authStore = useAuthStore();
const presenceStore = usePresenceStore();

const route = useRoute();

const instance = getCurrentInstance();

const email = ref(null);

const name = ref(null);

const getUserLogged = computed(() => {
  return authStore.getUserLogged;
});

const getReportPresence = computed(() => {
  return presenceStore.getReportPresence;
});

const getEmail = computed(() => {
  return email.value;
});

const getEmployee = computed(() => {
  return name.value;
});

async function getEmployeeById(id) {
  const res = await EmployeeService.getEmployee(id);
  name.value = res.data.fullName;
  email.value = res.data.email;
}

{
  if (route.params && route.params.id) {
    const report = getReportPresence.value.filter(v => v.id == route.params.id)[0];
    if (report && report.email) {
      email.value = report.email;
      name.value = report.name ?? null;
    } else {
      getEmployeeById(route.params.id);
    }
  }
}
</script>

<template>
  <presence-home :email="getEmail" :name="getEmployee">
    <template #header-actions>
      <router-link v-if="getUserLogged?.roles?.includes('ROLE_ADMIN')"
        :to="{ name: 'presence-report' }" class="btn btn-block m-2 btn-action btn_yellow d-inline-flex gap-2">
        <span aria-hidden="true">←</span> Volver al informe
      </router-link>
    </template>
  </presence-home>
</template>
